"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocaleCode;
(function (LocaleCode) {
    LocaleCode["DANISH"] = "da-DK";
    LocaleCode["ENGLISH_GB"] = "en-GB";
    LocaleCode["ENGLISH_US"] = "en-US";
    LocaleCode["ESTONIAN"] = "et-EE";
    LocaleCode["FINNISH"] = "fi-FI";
    LocaleCode["FRENCH"] = "fr-FR";
    LocaleCode["GERMAN"] = "de-DE";
    LocaleCode["HUNGARIAN"] = "hu-HU";
    LocaleCode["LATVIAN"] = "lv-LV";
    LocaleCode["LITHUANIAN"] = "lt-LT";
    LocaleCode["NORWEGIAN"] = "nb-NO";
    LocaleCode["POLISH"] = "pl-PL";
    LocaleCode["ROMANIAN"] = "ro-RO";
    LocaleCode["RUSSIAN"] = "ru-RU";
    LocaleCode["SLOVAK"] = "sk-SK";
    LocaleCode["SPANISH"] = "es-ES";
    LocaleCode["SWEDISH"] = "sv-SE";
})(LocaleCode = exports.LocaleCode || (exports.LocaleCode = {}));
//# sourceMappingURL=localeCode.js.map